// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1604":"css/admin-app.6799","6786":"css/app.6799"}[chunkId] + ".css";
};